import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	box: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
		width: 500,
		maxWidth: '100%',
	},
	container: {
		display: 'flex',
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: '20px',
		margin: 0,
	},
	header: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		lineHeight: '28px',
		margin: 0,
	},
	intro: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
	},
});
